import styled from 'styled-components';
import {type FC, useRef} from 'react';
import useCenterStore from '../../../store/useCenterStore.ts';
import LogoPNG from '../../../assets/common/logo-m.png';
import type {CenterInfo} from '../../../models';
import InformationSetting from '../InformationSetting.tsx';
import Logo from '../../../compoents/Logo.tsx';
import useModal from '../../../hooks/useModal.tsx';
import useGlobalStore from '../../../store/useGlobalStore.ts';
import {useNavigate} from 'react-router';
import {setFocus, useFocusable} from '@noriginmedia/norigin-spatial-navigation';

const LogoWrapper = styled.div<{$focused: boolean}>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-radius: 10px;
    padding: 0.5rem;
    border: ${({$focused}) => ($focused ? '2px solid #007bA1' : '2px solid transparent')};
    transition: border 0.2s ease;
`;

const CenterInfoWrapper = styled.div<{$focused: boolean}>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-radius: 10px;
    padding: 0.5rem;
    border: ${({$focused}) => ($focused ? '2px solid #007bA1' : '2px solid transparent')};
    transition: border 0.2s ease;
`;

const CenterInfo = styled.div`
    font-size: 1.5rem;
    font-weight: bold;
`;

const HomeIcon: FC = () => {
    const centerInfo = useCenterStore((state) => state.centerInfo);

    const {ref: logoRef, focused: logoFocused} = useFocusable({
        focusKey: 'home-logo',
        onArrowPress: (direction) => {
            if (direction === 'down') {
                setFocus('center-info');
                return false;
            }
            return direction !== 'left' && direction !== 'up';
        },
        onEnterPress: () => {
            if (window.electronAPI) {
                window.electronAPI.hardRefresh();
            } else {
                window.location.reload();
            }
        }
    });

    const {ref: centerInfoRef, focused: centerInfoFocused} = useFocusable({
        focusKey: 'center-info',
        onEnterPress: () => {
            handleOpenBasicModal();
        },
        onArrowPress: (direction) => {
            if (direction === 'up') {
                setFocus('home-logo');
                return false;
            }
            if (direction === 'down') {
                setFocus('weather');
                return false;
            }
            return direction !== 'left';
        },
    });

    const clickCountRef = useRef(0);
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const navigate = useNavigate();
    const handleImageClick = () => {
        clickCountRef.current += 1;
        if (clickCountRef.current === 1) {
            timerRef.current = setTimeout(async () => {
                if (clickCountRef.current < 5) {
                    if (window.electronAPI) {
                        window.electronAPI.hardRefresh();
                    } else {
                        window.location.reload();
                    }
                }
                clickCountRef.current = 0;
                timerRef.current = null;
            }, 2000);
        }
        if (clickCountRef.current === 5) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
            clickCountRef.current = 0;
            navigate('/error');
        }
    };

    const {generateId} = useGlobalStore();
    const {showModal} = useModal();
    const handleOpenBasicModal = () => {
        showModal(generateId(), InformationSetting);
    };

    return (
        <>
            <LogoWrapper ref={logoRef} $focused={logoFocused}>
                <Logo iconWidth={'12rem'}>
                    <img src={LogoPNG} alt={'logo'} onClick={handleImageClick} />
                </Logo>
            </LogoWrapper>
            {centerInfo && (
                <CenterInfoWrapper ref={centerInfoRef} $focused={centerInfoFocused}>
                    <CenterInfo onClick={handleOpenBasicModal}>
                        <h3>{centerInfo.name}</h3>
                        <h3>{centerInfo.center_id}</h3>
                    </CenterInfo>
                </CenterInfoWrapper>
            )}
        </>
    );
};
export default HomeIcon;
